// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsbclpc{width:17pc}\n._4t3i1osq{height:100%}\n._n3tdxncg{padding-bottom:var(--ds-space-800,4pc)}\n._p12f1dup{max-width:424px}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
